export default __webpack_public_path__ + "static/media/01.7d8cec72.jpg";